import axios from "axios";
import * as GlobalService from './../global_services';

export function saveSettings(data) {
    return axios.put('/WebUI/Settings/CustomLabels/CustomLabels', data).then(function (response) {
        return response;
    })
}